import "../../styles/Home.css";

import React, { useEffect, useState } from "react";

import BlogPosts from "../../components/templates/BlogPost/BlogPosts.jsx";
import Button from "../atoms/Button.js";
import Contact from "../../components/templates/Contact.jsx";
import FAQSection from "../../components/templates/FAQSection.jsx";
import Footer from "../../components/templates/Footer.jsx";
import HomeTutorial from "../templates/HomeTutorial.jsx";
import Label from "../atoms/Label.js";
import Login from "../../features/Login.jsx";
import SignUp from "../../features/SignUp.jsx";
import Testimonials from "./Testimonials.jsx";
import backgroundImage from "../../assets/ic_home_background.svg";
import bgTestimonials from "../../assets/ic_testimonials_bg.svg";
import ic_frame_975 from "../../assets/ic_frame_975.svg";
import ic_sat_image from "../../assets/ic_sat_image.svg";
import rightArrow from "../../assets/ic_right_arrow.svg";
import roundBlue from "../../assets/ic_round_blue.svg";
import { useHomePageData } from "../../hooks/useHomePageData";
import { useSelector } from "react-redux";

const HomePage = (propData) => {
	const [email, setEmail] = useState("");
	const { blogData, testimonialsData, faqData, isLoading, error } = useHomePageData();
	const {
		isLoginModalOpen,
		isSignUpModalOpen,
		handleOverlayClick,
		closeLoginModal,
		closeSignUpModal,
		openLoginModal,
		openSignUpModal,
	} = propData;
	const { isAuthenticated } = useSelector((state) => state.userDetails);
	return (
		<div style={{ maxWidth: "100vw", overflowX: "hidden" }}>
			{isLoginModalOpen && (
				<div
					className='modal-overlay'
					onClick={(e) => handleOverlayClick(e, closeLoginModal)}>
					<div className='modal-container'>
						<Login
							openSignUpModal={openSignUpModal}
							closeLoginModal={closeLoginModal}
						/>
					</div>
				</div>
			)}
			{isSignUpModalOpen && (
				<div
					className='modal-overlay'
					onClick={(e) => handleOverlayClick(e, closeSignUpModal)}>
					<div className='modal-container'>
						<SignUp
							openLoginModal={openLoginModal}
							closeSignUpModal={closeSignUpModal}
							setEmail={setEmail} // Pass setEmail to SignUp component
						/>
					</div>
				</div>
			)}

			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					minHeight: "calc(75vh - 69px)",
					width: "100%",
					backgroundImage: `url(${backgroundImage})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}>
				<div className='home-page-1'>
					<div className='home-page-2'>
						<Label
							label='Your Personalized Path to SAT Excellence with AI-Powered Intelligent Tutoring'
							fontSize={"48px"}
							padding={"10px"}
							color={"#FFFFFF"}
							fontWeight={"700"}
							textAlign='left'
						/>
						{!isAuthenticated ? (
							<Button
								onClick={openSignUpModal}
								style={{
									marginBottom: "8px",
									marginTop: "20px",
									marginLeft: "10px",
								}}
								className='join-now-button'
								label='Join Now For Free'
							/>
						) : (
							<div
								style={{
									marginBottom: "8px",
									marginTop: "20px",
									marginLeft: "10px",
								}}></div>
						)}
					</div>
					<div className='home-page-3'>
						<img src={ic_sat_image} alt='SAT Image' />
					</div>
				</div>
				<div className='home-page-4'>
					<Label
						label='Build Confidence with Personalized AI-Driven SAT Study Plans.'
						fontSize={"20px"}
						padding={"10px"}
						color={"#FFFFFF"}
						fontWeight={"700"}
						textAlign='center'
					/>
				</div>
			</div>

			<div
				style={{
					backgroundColor: "#0A0240",
					minHeight: "137px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexDirection: "column",
					padding: "40px 0",
				}}>
				<Label
					style={{ marginBottom: "20px" }}
					label='Why us'
					fontSize={"32px"}
					padding={"10px"}
					color={"#FFFFFF"}
					fontWeight={"700"}
					textAlign='center'
				/>
				<div className='home-page-8-content-container'>
					<div className='home-page-8'>
						<div className='home-page-8-content'>
							<img src={rightArrow} alt='Right Arrow' />
							<Label
								label='Looking for a smarter, more efficient way to prepare for the SAT without overwhelming your busy school schedule?'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"700"}
								textAlign='left'
							/>
						</div>

						<div className='home-page-8-content'>
							<img src={roundBlue} alt='Right Arrow' />
							<Label
								label='Our AI-powered platform adapts to your learning pace, making prep time efficient, targeted, and manageable.'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
						</div>
					</div>
					<div className='home-page-8'>
						<div className='home-page-8-content'>
							<img
								src={rightArrow}
								style={{ width: "20px", height: "20px" }}
								alt='Right Arrow'
							/>
							<Label
								label='Struggling to motivate your high schooler to reach their full potential on the SAT?'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"700"}
								textAlign='left'
							/>
						</div>

						<div className='home-page-8-content'>
							<img src={roundBlue} alt='Right Arrow' />
							<Label
								label='With engaging, personalized tools, we make SAT prep exciting, helping students stay committed to their goals.'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
						</div>
					</div>
					<div className='home-page-8'>
						<div className='home-page-8-content'>
							<img src={rightArrow} alt='Right Arrow' />
							<Label
								label="Concerned that traditional prep methods aren't addressing your unique strengths and weaknesses?"
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"700"}
								textAlign='left'
							/>
						</div>

						<div className='home-page-8-content'>
							<img src={roundBlue} alt='Right Arrow' />
							<Label
								label='Our platform pinpoints your specific areas for improvement, so you can focus on what truly matters for score growth.'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
						</div>
					</div>

					<div className='home-page-8'>
						<div className='home-page-8-content'>
							<img src={rightArrow} alt='Right Arrow' />
							<Label
								label='Worried about missing out on competitive SAT scores that open doors to top colleges?'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"700"}
								textAlign='left'
							/>
						</div>

						<div className='home-page-8-content'>
							<img src={roundBlue} alt='Right Arrow' />
							<Label
								label='Join thousands of students who are boosting their scores with our data-driven approach and gaining a competitive edge in college admissions.'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
						</div>
					</div>

					<div className='home-page-8'>
						<div className='home-page-8-content'>
							<img src={rightArrow} alt='Right Arrow' />
							<Label
								label='Want an SAT prep solution that combines expert insights with next-gen AI technology?'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"700"}
								textAlign='left'
							/>
						</div>

						<div className='home-page-8-content'>
							<img src={roundBlue} alt='Right Arrow' />
							<Label
								label='Our system blends proven techniques with the latest AI innovations to deliver personalized, results-oriented learning.'
								fontSize={"16px"}
								padding={"10px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
						</div>
					</div>
				</div>

				{!isAuthenticated && (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexDirection: "row",
						}}>
						<Button
							style={{
								marginTop: "40px",
								borderRadius: "12px",
								backgroundColor: "#1F21E6",
							}}
							className='join-now-button'
							label='Join Now For Free'
							onClick={openSignUpModal}
						/>
					</div>
				)}
			</div>
			<HomeTutorial
				heading={"Personalized Knowledge Concept (KC) Learning console"}
				description={
					"Dive into personalized SAT learning with our Knowledge Concept Console. Easily navigate topics, generate quizzes, create flashcards, and review videos - all tailored to your unique learning needs."
				}
				url={"https://www.youtube.com/watch?v=IqMaKCdP-M8&t=9s"}
			/>
			<div
				style={{
					width: "100%",
					height: "1px",
					backgroundColor: "#000000",
					margin: "20px 0",
				}}
			/>
			<HomeTutorial
				heading={"Flashcard System"}
				description={
					"Boost your memory retention with our intelligent flashcard system. Automatically generated flashcards focus on your weak areas, while spaced repetition helps you master concepts over time."
				}
				url={"https://www.youtube.com/watch?v=IqMaKCdP-M8&t=9s"}
			/>
			<div
				style={{
					width: "100%",
					height: "1px",
					backgroundColor: "#000000",
					margin: "20px 0",
				}}
			/>
			<HomeTutorial
				heading={"Mock Test Feature"}
				description={
					"Simulate the real SAT experience with our mock tests. Track your progress with detailed score dashboards and pinpoint weaknesses with in-depth error analysis."
				}
				url={"https://www.youtube.com/watch?v=IqMaKCdP-M8&t=9s"}
			/>
			<div
				style={{
					width: "100%",
					height: "1px",
					backgroundColor: "#000000",
					margin: "20px 0",
				}}
			/>
			<HomeTutorial
				heading={"Gamification & Community Features"}
				description={
					"Stay motivated with gamification! Earn badges, climb leaderboards, and join a vibrant community of learners to share tips and strategies."
				}
				url={"https://www.youtube.com/watch?v=IqMaKCdP-M8&t=9s"}
			/>

			<div
				style={{
					// backgroundImage: `url(${bgTestimonials})`,
					backgroundColor: "#f9f9f9",
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}>
				{testimonialsData && <Testimonials testimonials={testimonialsData} />}
			</div>
			{blogData && <BlogPosts posts={blogData} />}
			<Contact />
			<FAQSection faqData={faqData} />
			<Footer />
		</div>
	);
};

export default HomePage;
